import BaseAPI from "./BaseAPI";
import { departmentRoute } from "../routes";

export default class DepartmentAPI extends BaseAPI {
    constructor(emitterInstance) {
        super(emitterInstance, departmentRoute, "department");
    }
}
